// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"show-more-m__wrapper__1bK86","content":"show-more-m__content__36EMH"};